import { useEffect, useState } from "react";
import SettingsForm from "../../forms/Settings";
import {
  GetStoreDetails,
  UpdateStoreDetails,
} from "../../services/storeDetails";
import { GeneratePresignedUrl, UploadFile } from "../../services/media";

const Settings = () => {
  const [storeDetails, setStoreDetails] = useState({});

  const fetchStoreDetail = async () => {
    const { data } = await GetStoreDetails();
    if (data.result) {
      setStoreDetails(data.result);
    }
  };
  useEffect(() => {
    fetchStoreDetail();
  }, []);
  const handleSubmit = async (details) => {
    return UpdateStoreDetails(details);
  };
  const handleFileUpload = async (file) => {
    if (file) {
      const { data } = await GeneratePresignedUrl({
        fileName: file.name,
        fileType: file.type,
      });
      if (data.result) {
        const { presignedUrl, downloadUrl } = data.result;

        const res = await UploadFile({ file, url: presignedUrl });
        if (res.status === 200) {
          return downloadUrl;
        } else {
          throw new Error("Could not upload the file.");
        }
      }
    }
  };

  return (
    <>
      <SettingsForm
        onSubmit={handleSubmit}
        editable={true}
        initialData={storeDetails}
        handleFileUpload={handleFileUpload}
      />
    </>
  );
};

export default Settings;
